<div
  class="card si-card h-100"
  [class.si-card--accent]="!!accent"
  [class.si-card--accent-danger]="accent === 'danger'"
  [style.border-top-color]="accent && accent !== 'danger' && accentRgb ? 'rgb(' + accentRgb + ')' : null"
>
  <div class="card-body si-card__body">
    @if (cardTitle || subtitle) {
      <div class="si-card__head">
        <div class="si-card__heading">
          @if (cardTitle) {
            <h3 class="si-card__title text-truncate" [title]="cardTitle | translate">{{ cardTitle | translate }}</h3>
          }
          @if (subtitle) {
            <p class="si-card__subtitle">{{ subtitle | translate }}</p>
          }
        </div>
        <div class="si-card__actions">
          <ng-content select="[cardActions]"></ng-content>
        </div>
      </div>
    }
    <ng-content select="[cardToolbar]"></ng-content>
    <div class="si-card__content">
      @if (error) {
        <div class="si-card__state si-card__state--error text-danger">
          <i class="fa-solid fa-triangle-exclamation me-2"></i>{{ error | translate }}
        </div>
      } @else if (loading) {
        <div class="si-card__state">
          <span class="spinner-border spinner-border-sm text-primary" role="status"></span>
        </div>
      } @else if (empty) {
        <div class="si-card__state text-body-secondary">{{ 'SALES_INSIGHTS_NO_DATA' | translate }}</div>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  </div>
</div>
